import { PriceInfoService } from '@qover/services';
import { GetPriceInfoResponse } from '@qover-private/protos-web/qover/dojo/pricing/v1/pricing';
import { BASE_PATH as basePath } from '../utils/trConstants';
import PriceInfo from '../domain/PriceInfo';

export const priceInfoService = new PriceInfoService(basePath, {
  create: (x: GetPriceInfoResponse) =>
    new PriceInfo(x.priceInfo as any, x.basePriceInfo as any),
});
